require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2007-07-happy-4th.json") })
        }
      }, "path---articles-2007-07-happy-4th");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2007-07-happy-4th!./.cache/json/articles-2007-07-happy-4th.json
// module id = 379
// module chunks = 231608221292675